module.exports = __webpack_public_path__ + "static/img/expect.99fc228f.svg";